import type { RouteRecordRaw } from "vue-router";
import { APP_CHAT_CUSTOMER_ROUTES } from "@/Generated/Routes/paths";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    ...APP_CHAT_CUSTOMER_ROUTES.questionnaires.root,
    component: () => import("@/Views/chat/customer/views/Questionnaires/QuestionnairesList.vue"),
    meta: {
      i18nTitle: "questionnaires",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.questionnaires.answers.root,
    component: () => import("@/Views/chat/customer/views/Questionnaires/QuestionnairesAnswers.vue"),
    meta: {
      i18nTitle: "",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.questionnaires.send.root,
    component: () => import("@/Views/chat/customer/views/Questionnaires/SendQuestionnaireList.vue"),
    meta: {
      i18nTitle: "customer.questionnaires.send_form",
    },
  },
];

export default CustomerRoutes;
